import React from 'react';
import { Route, Router } from 'react-router-dom';
import { PsRoutes } from './Routes';
import AlertComponent from '../alert/AlertComponent';
import LoginScreen from '../../login/screens/LoginScreen';
import RememberPasswordScreen from '../../login/screens/RememberPasswordScreen';
import ResetPasswordScreen from '../../login/screens/ResetPasswordScreen';

export class NoAuthRouting extends React.Component {
    render() {
        return (
            <Router history={this.props.history}>
                <div>
                    <Route path="/" component={AlertComponent}/>
                    <Route path={PsRoutes.HOME} exact component={LoginScreen}/>
                    <Route path={PsRoutes.PASSWORD_RECOVER} exact component={RememberPasswordScreen}/>
                    <Route path={PsRoutes.PASSWORD_RESTORE} exact component={ResetPasswordScreen}/>
                </div>
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/routing/NoAuthRouting.jsx